// ==================== CONFIGURACIÓN GENERAL DEL ENTORNO ====================
export const environment = {
  production: false,
  version: '0.1.2',
  tokenFijo: 'Fdsjh34hj34HJF324cd%kj234-3433dsfIyfvbjwGGFHsd23t453$',
  backUrlApi: 'https://apiv2.dev.misionempresarial.com/api/', //TODO> Cambiar URL al desplegar en DEV
  homeImagesUrl: 'https://apiv2.dev.misionempresarial.com', //TODO> Cambiar URL al desplegar en DEV
  redirectUriAzureLogin: 'https://nexus.dev.misionempresarial.com/login/azure-auth', // URL de redirección para el login de Azure
  timeHomeNews: 5,
  noPic: '../assets/images/profile/nopic.png', // Imagen por defecto para usuarios sin foto de perfil
  rollbarToken: '6b04a2dd396648f893c23e54b7877960370a8bce923c7263c7fa50ff486e3b3ba13ba4d4295d658471733f6568f2fc73',
  rollbarEnvironment: 'development'
};
